var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.state.chainData.chainId !== '0x38')?_c('CustomButton',{key:"switchNetwork-button",on:{"click":function($event){return _vm.$store.dispatch('switchChain')}}},[_vm._v(" "+_vm._s(_vm.$t('wrong_network.switch_to_bsc')))]):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }